import React, { useState } from 'react';
import { Filter, ChevronUp, ChevronDown, List, BarChart3, Globe, Trash2 } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
export function StationFilters() {
  const [isOpen, setIsOpen] = useState(true);
  return <div className="absolute top-6 left-6 z-[1000] w-[300px] rounded-2xl border border-white/[0.08] shadow-2xl shadow-black/40 flex flex-col overflow-hidden" style={{
    background: 'rgba(15, 23, 42, 0.55)',
    backdropFilter: 'blur(40px) saturate(180%)',
    WebkitBackdropFilter: 'blur(40px) saturate(180%)'
  }} data-id="element-1091">
      {/* Inner glow border effect */}
      <div className="absolute inset-0 rounded-2xl pointer-events-none" style={{
      background: 'linear-gradient(135deg, rgba(255,255,255,0.06) 0%, transparent 50%, rgba(255,255,255,0.02) 100%)'
    }} data-id="element-1092" />

      {/* Header */}
      <div className="relative flex items-center justify-between p-4 border-b border-white/[0.06] cursor-pointer hover:bg-white/[0.03] transition-colors" onClick={() => setIsOpen(!isOpen)} data-id="element-1093">
        <div className="flex items-center gap-2 text-white/90 font-medium" data-id="element-1094">
          <Filter size={16} className="text-white/60" data-id="element-1095" />
          <span data-id="element-1096">Station Filters</span>
        </div>
        {isOpen ? <ChevronUp size={16} className="text-white/40" data-id="element-1097" /> : <ChevronDown size={16} className="text-white/40" data-id="element-1098" />}
      </div>

      {isOpen && <div className="relative p-4 space-y-5" data-id="element-1099">
          {/* Region Selection */}
          <div className="space-y-3" data-id="element-1100">
            <div className="flex items-center gap-2 text-xs font-medium text-white/50 uppercase tracking-wider" data-id="element-1101">
              <div className="h-2.5 w-2.5 rounded-full bg-[#EC4899] shadow-[0_0_6px_rgba(236,72,153,0.4)]" data-id="element-1102" />
              Region Selection
            </div>
            <div className="flex items-center gap-2" data-id="element-1103">
              <Button variant="outline" className="flex-1 justify-center gap-2 text-white/80 border-white/[0.1] bg-white/[0.06] hover:bg-white/[0.1] h-9 text-sm rounded-lg" data-id="element-1104">
                <Globe size={14} data-id="element-1105" />
                Select Region
              </Button>
              <Button variant="primary" className="justify-center gap-1.5 bg-red-500/70 hover:bg-red-500/90 text-white h-9 text-sm px-3 shadow-none rounded-lg" data-id="element-1106">
                <Trash2 size={14} data-id="element-1107" />
                Clear
              </Button>
            </div>
          </div>

          {/* Stats */}
          <div className="space-y-1.5" data-id="element-1108">
            <div className="flex justify-between text-sm" data-id="element-1109">
              <span className="text-white/45" data-id="element-1110">Filtered:</span>
              <span className="font-bold text-white" data-id="element-1111">292</span>
            </div>
            <div className="flex justify-between text-sm" data-id="element-1112">
              <span className="text-white/45" data-id="element-1113">Total:</span>
              <span className="font-medium text-white/70" data-id="element-1114">9772</span>
            </div>
          </div>

          {/* Actions */}
          <div className="space-y-3 pt-1" data-id="element-1115">
            <Button className="w-full gap-2 bg-[#EC4899]/90 hover:bg-[#EC4899] text-white shadow-lg shadow-pink-500/20 h-10 rounded-lg" data-id="element-1116">
              <List size={16} data-id="element-1117" />
              View Stations (292)
            </Button>
            <Button variant="outline" className="w-full gap-2 text-slate-800 border-white/80 hover:border-white/90 hover:bg-white/60 h-10 rounded-lg" data-id="element-1118">
              <BarChart3 size={16} data-id="element-1119" />
              Compute Benchmarks
            </Button>
          </div>
        </div>}
    </div>;
}